import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Field } from 'react-final-form';
import { FormGroupAdapter } from 'components/shared/form';

const ItalicText = styled.span`
  font-style: italic;
`;

function WrittenConsentProvidedCheckbox({ fz }) {
  return (
    <Field
      name="application.writtenConsentProvided"
      id="writtenConsentProvided"
      mb={0}
      type="checkbox"
      fz={fz}
      component={FormGroupAdapter}
    >
      <ItalicText>
        I consent to contact from LendingOne at the number I provided regarding its products and services, via call or SMS text, including the use of an automated telephone dialing system, artificial or prerecorded voice, or similar technology. I understand that my consent is not required to purchase or obtain any products and services. I may revoke my consent at any time, including by replying STOP to text messages or by any other reasonable means.
      </ItalicText>
    </Field>
  );
}

WrittenConsentProvidedCheckbox.propTypes = {
  fz: PropTypes.number,
};

WrittenConsentProvidedCheckbox.defaultProps = {
  fz: 0.825,
};

export default WrittenConsentProvidedCheckbox;
